import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Typography, Divider, Button, Grid, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Paper, TextField, Select, MenuItem } from '@mui/material';
import TablePaginationActions from '../../components/TablePaginationActions';
import axios from 'axios';
  
import AppContext from '../../components/AppContext';
import ErrorHandler from '../../components/ErrorHandler';
import Loading from '../../components/Loading';

import Config from '../../utils/Config';
import {TimestampToDateTime} from '../../utils/Helpers';

export default function List() {
  const navigate = useNavigate();

  const [data, setData] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filter, setFilter] = useState({name: "", type: "", idNumber: "", taxNumber: ""});

  const [filterField1, setFilterField1] = useState('');
  const [filterField2, setFilterField2] = useState('');
  const [filterField3, setFilterField3] = useState('');
  const [filterField4, setFilterField4] = useState('');

  const { appContext } = React.useContext(AppContext);

  //console.log(userToken)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(Config.BASE_URL + '/admin/collaborators/list', {
          headers: {
            Authorization: 'Bearer ' + appContext.userToken, 
            'Cache-Control': 'no-cache',
          },
        });

        setData(response.data);
      } catch (error) {
        console.error(error);
        ErrorHandler(error.response, {'userToken': appContext.userToken, 'signOut': appContext.signOut});
      }
    };

    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSetFilterButtonClick = () => {
    setFilter({name: filterField1, type: filterField2, idNumber: filterField3, taxNumber: filterField4});
    setPage(0);
  };

  const handleClearFilterButtonClick = () => {
    setFilterField1('');
    setFilterField2('');
    setFilterField3('');
    setFilterField4('');

    setFilter({name: "", type: "", idNumber: "", taxNumber: ""});
  };

  console.log(data)
  
  if (data === false) {
    return (<Loading />);
  }

  // Handle Enter key press
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent default behavior (e.g., new line in textarea)
      handleSetFilterButtonClick();
    }
  };

  const rows = data.filter((el) => el.name.toLowerCase().includes(filter.name.toLowerCase()))
                   .filter((el) => (el.type || '').toLowerCase().includes(filter.type.toLowerCase()))
                   .filter((el) => (el.idNumber || '').toLowerCase().includes(filter.idNumber.toLowerCase()))
                   .filter((el) => (el.taxNumber || '').toLowerCase().includes(filter.taxNumber.toLowerCase()));

  return (
      <Container maxWidth="false">
        <Grid container spacing={1} sx={{ my: 2 }}>
          <Grid item xs={10}>
            <Typography variant="h4">Saradnici</Typography>
          </Grid>
          <Grid item xs={2} textAlign="right">
            <Button variant="contained" color="success" onClick={() => navigate('/collaborators/add')}>Dodaj saradnika</Button>
          </Grid>
        </Grid>
        <Divider light />
        <Grid container spacing={1} sx={{ my: 2 }} onKeyDown={handleKeyDown}>
          <Grid item xs={1} textAlign="center">
            Ukupno: {rows.length}
          </Grid>
          <Grid item xs={2} textAlign="center">
            <TextField label="Naziv" value={filterField1} onChange={(e) => setFilterField1(e.target.value)} variant="outlined" size="small" InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={2} textAlign="center">
            <TextField select fullWidth label="Tip" value={filterField2} onChange={(e) => setFilterField2(e.target.value)} variant="outlined" size="small" InputLabelProps={{ shrink: true }} >
              <MenuItem value={"Agencija"}>Agencija</MenuItem>
              <MenuItem value={"AO osiguranje"}>AO osiguranje</MenuItem>
              <MenuItem value={"Kasko osiguranje"}>Kasko osiguranje</MenuItem>
              <MenuItem value={"Pomoć na putu"}>Pomoć na putu</MenuItem>
              <MenuItem value={"Servis"}>Servis</MenuItem>
              <MenuItem value={"Tehnički pregled"}>Tehnički pregled</MenuItem>
              <MenuItem value={"Zamena pneumatika"}>Zamena pneumatika</MenuItem>
          </TextField>
          </Grid>
          <Grid item xs={2} textAlign="center">
            <TextField label="Matični broj" value={filterField3} onChange={(e) => setFilterField3(e.target.value)} variant="outlined" size="small" InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={2} textAlign="center">
            <TextField label="PIB" value={filterField4} onChange={(e) => setFilterField4(e.target.value)} variant="outlined" size="small" InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={3} textAlign="right">
            <Button variant="contained" color="primary" sx={{ mx: 1 }} onClick={handleSetFilterButtonClick}>Primeni</Button>
            <Button variant="contained" color="error" onClick={handleClearFilterButtonClick}>Reset</Button>
          </Grid>
        </Grid>
        <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              labelRowsPerPage="Redova po stranici"
          />
          <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead color="secondary">
              <TableRow>
                  <TableCell>Naziv</TableCell>
                  <TableCell align="left">Tip</TableCell>
                  <TableCell align="left">Matični broj</TableCell>
                  <TableCell align="left">PIB</TableCell>
                  <TableCell align="left">Upisan</TableCell>
                  <TableCell align="left"></TableCell>
              </TableRow>
              </TableHead>
              <TableBody>
              {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                  <TableRow
                  key={row.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, 
                        '&:nth-of-type(even)': { backgroundColor: "#f6f6f6" },
                        '&:hover': { backgroundColor: "#fffbc7", cursor: 'pointer' } }}
                  onClick={() => navigate('/collaborators/view?id=' + row.id)}
                  >
                  <TableCell component="th" scope="row">{row.name}</TableCell>
                  <TableCell align="left">{row.type}</TableCell>
                  <TableCell align="left">{row.idNumber}</TableCell>
                  <TableCell align="left">{row.taxNumber}</TableCell>
                  <TableCell align="left">{TimestampToDateTime(row.created)}</TableCell>
                  <TableCell align="left"><Button variant="text" color="secondary" size="small" sx={{m:0, p:0}} onClick={(e) => { navigate('/collaborators/edit?id=' + row.id); e.stopPropagation(); }}>Izmeni</Button></TableCell>
                  </TableRow>
              ))}
              </TableBody>
          </Table>
          </TableContainer>
          <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              labelRowsPerPage="Redova po stranici"
          />
      </Container>
  );
}
